import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useLocation } from 'react-router-dom';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { FooterRow, IFooterRowProps } from '@sharedComponents/FooterRow';
import { EPage, ReactFCV } from '@types';
import { getPageFromRoute } from '@utils/routing';

import { DiscountCodeAnchor } from './DiscountCodeAnchor';
import { IStickyFooterRow } from './model';
import { FixedWrapper, StyledButtonWrapper, StyledPageFooterRow } from './styled';

export const StickyFooterRow: ReactFCV<IStickyFooterRow> = ({
  isStickyAvailable,
  threshold = 1,
  stickyFirstButtonPropsOverride,
  stickySecondButtonPropsOverride,
  price,
  ...props
}) => {
  const {
    applicationSettings: {
      features: { enableStickyButtonsOnCart },
    },
  } = useApplicationRuntimeContext();

  const { pathname } = useLocation();
  const currentPage = getPageFromRoute(pathname);
  const areStickyButtonsEnabledOnCart = enableStickyButtonsOnCart && currentPage === EPage.CART;

  const derivedProps: IFooterRowProps = {
    ...props,
    ...(props['data-testid'] && { 'data-testid': `${props['data-testid']}-sticky` }),
    ...(price && {
      priceProps: {
        price,
        'data-testid': 'total-price-sticky',
      },
    }),
    firstButtonProps: {
      ...props.firstButtonProps,
      ...stickyFirstButtonPropsOverride,
    },
    secondButtonProps: {
      ...props.secondButtonProps,
      ...stickySecondButtonPropsOverride,
    },
  };

  const { ref, inView } = useInView({ threshold });

  const isSticky = isStickyAvailable && !inView;
  return (
    <div ref={ref}>
      {isSticky && (
        <FixedWrapper>
          <StyledButtonWrapper>
            {areStickyButtonsEnabledOnCart && <DiscountCodeAnchor />}
            <FooterRow {...derivedProps} />
          </StyledButtonWrapper>
        </FixedWrapper>
      )}
      <StyledPageFooterRow {...props} />
    </div>
  );
};
